import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_AUTH_URL } from '../config/settings/environment'

/**
 * Gets a valid public token.
 */
export const getPublicToken = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_AUTH_URL}/v1/auth/publico`, { isPublic: true })
})

/**
 * Gets the user info contained in the token.
 */
export const getAuthInfo = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_AUTH_URL}/v1/auth/info`)
})
